// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2kow1","title":"ClientReferral_title__2w88M","itemText":"ClientReferral_itemText__lrwPT"};